import styled from 'styled-components';

export const GreetingHeading = styled.h1`
  font-size: 1.5rem;
  font-family: ${Styles.fontFamily.brand};
  font-weight: bold;
  margin: 0 0 0.875rem 0;
  text-align: left;
  span {
    display: block;
  }
  ${Styles.desktop`
    font-size: 3.125rem;
    text-align: center;
    span {
      display: unset;
    }
  `}
  div {
    display: none;
  }
`;

export const GreetingText = styled.div`
  color: ${Styles.color.white};

  span {
    font-family: ${Styles.fontFamily.brand};
  }
  div {
    margin-left: 0.625rem;
  }
`;
